export const documentTransmittalDataGrid = [
  {
    label: "Number",
    field: "number",
    grid: 0.8,
    options: [],
  },

  {
    label: "Date",
    field: "date",
    grid: 0.5,
  },
];

export const purposeInput = {
  label: "Purpose",
  field: "purpose",
  grid: 0.8,
  options: [
    "Issued for Review",
    "Issued for Approval",
    "Issued for Construction",
    "As-Built",
  ],
};

export const projectDataGrid = [
  {
    label: "WBS",
    field: "name",
    grid: 1.2,
  },

  {
    label: "WBS Rev",
    field: "rev",
    grid: 1.2,
  },
  // {
  //   label: "WBS Type",
  //   field: "type",
  //   grid: 1.2,
  // },
];

export const clientDataGrid = [
  {
    label: "Client Name",
    field: "name",
    grid: 1.2,
  },
  {
    label: "Client Email",
    field: "email",
    grid: 1.2,
  },
];

export const vendorDataGrid = [
  {
    label: "Vendor Name",
    field: "name",
    grid: 1.2,
  },
  {
    label: "Vendor Email",
    field: "email",
    grid: 1.2,
  },
];
